import { render, staticRenderFns } from "./DCXImageGallery.vue?vue&type=template&id=aabb16e2&"
import script from "./DCXImageGallery.vue?vue&type=script&lang=js&"
export * from "./DCXImageGallery.vue?vue&type=script&lang=js&"
import style0 from "./DCXImageGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports